import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OrderPlaceModel, ProductSort } from '../models/Home/home-list.model';
import { GetProductAssetModel, ProductWarrantyItemList, ProductWarrantyServiceModel } from '../models/product/productAssets.modal';
import { RelatedProductListItem } from '../models/product/relatdProduct';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class HomePageService {

  constructor(private _api: ApiService) { }

  productCondition = new BehaviorSubject(<string>'');
  
  setProductCondition(productCondition) {
    this.productCondition.next(productCondition);
  }

  ProductContentList(contentlist: ProductSort) {
    return this._api.post(UrlHelperService.homePageContentListing, contentlist, false)
  }
  ProductImageList(productId) {
    return this._api.post(UrlHelperService.homePageImageListing + productId)
  }
  GetProductMultipleImage(productAssetsDetails: GetProductAssetModel) {
    return this._api.post(UrlHelperService.ProductMultipleImage, productAssetsDetails)
  }
  GetProductDetail(productModel: GetProductAssetModel) {
    return this._api.post(UrlHelperService.getProductAssetContent + productModel.ProductId)
  }
  BuyNowProductOrder(productId) {
    return this._api.post(UrlHelperService.buyNowCustomerProductOrder + productId)
  }
  getCategoryId = new BehaviorSubject(<string>'');
  passCategoryId(id) {
    this.getCategoryId.next(id);
  }
  getWarrantyId = new BehaviorSubject(<string>'');
  passId(warrantyId) {
    this.getWarrantyId.next(warrantyId);
  }
  ProductCustomerList(productAssetsDetails: GetProductAssetModel) {
    return this._api.post(UrlHelperService.customerOrderListing, productAssetsDetails)
  }
  GetOrderWarrantyDetails(productId, id, warrantyId, warrantyPriceId, isApplicationPriceSelected) {
    return this._api.get(UrlHelperService.WarrantyOrderDetailsListing + productId + '/' + id + '/' + warrantyId + '/' + warrantyPriceId + '/' + isApplicationPriceSelected)
  }
  GetOrderDetails(productId, id) {
    return this._api.get(UrlHelperService.CustomerOrderDetailsListing + productId + '/' + id)
  }
  WarrantyCustomerOrderPlace(productId, getAddressId, deliveryRateId, warrantyId, warrantyPriceId, isApplicationPriceSelected) {
    return this._api.post(UrlHelperService.CustomerOrderSubscriptionIntent + productId + '/' + getAddressId + '/' + deliveryRateId + '/' + warrantyId + '/' + warrantyPriceId + '/' + isApplicationPriceSelected)
  }
  CustomerOrderPlace(productId, getAddressId, deliveryRateId) {
    return this._api.post(UrlHelperService.CustomerOrderSubscriptionIntent + productId + '/' + getAddressId + '/' + deliveryRateId)
  }
  CustomerPlaceOrder(orderPlaceModelVM: OrderPlaceModel){
    return this._api.post(UrlHelperService.CustomerPlaceOrderPayment,orderPlaceModelVM)
  }
  CustomerProductImage(productAssetsDetails: GetProductAssetModel) {
    return this._api.post(UrlHelperService.GetProductImageListing, productAssetsDetails)
  }
  GetProductSingleImage(ProductId) {
    return this._api.post(UrlHelperService.CustomerProducSingleImageListing + ProductId)
  }
  GetProductWarrantyServiceList(warrantyServiceVM: ProductWarrantyServiceModel) {
    return this._api.post(UrlHelperService.getProductWarrantyServiceList + warrantyServiceVM.ProductId, warrantyServiceVM)
  }

  RelatedProductListing(relatedProductVM: RelatedProductListItem) {
    return this._api.post(UrlHelperService.getRelatedProductList, relatedProductVM)
  }

  getProductType = new BehaviorSubject(<any>'');
  passProductType(type) {
    this.getProductType.next(type);
  }
  
  getResetFilters = new BehaviorSubject(<string>'');
  resetFilters(action){
    this.getResetFilters.next(action);
  }

  getSearchFilters = new BehaviorSubject(<string>'');
  searchFilters(search){
    this.getSearchFilters.next(search);
  }
}